import LogoutIcon from "@mui/icons-material/Logout";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { keyApp, useStore } from "hooks/useStore";
import { LOGIN_PAGE } from "utils/axiosInterceptors";

function VidletBtnLogout() {
  const requestLogout = useStore((s) => s[keyApp].requestLogout);

  return (
    <IconButton
      color="inherit"
      onClick={() => {
        requestLogout(() => {
          window.location.pathname = LOGIN_PAGE;
        });
      }}
    >
      <LogoutIcon className="vidlet-icon-logout" />
      <Typography pl={0.5} color="inherit">
        SIGN OUT
      </Typography>
    </IconButton>
  );
}

export default VidletBtnLogout;
